<template>
    <m-accordion expand class="elevation-0 m-accordion-primary" v-bind="$attrs" v-on="$listeners">
        <slot/>
    </m-accordion>
</template>

<script>
    import MAccordion from "@modules/accordions/m-accordion";

    export default {
        components: {MAccordion},
        inheritAttrs: false,
        name: "m-accordion-primary"
    }
</script>

<style lang="scss">
    .m-accordion-primary {
        .v-expansion-panel {
            &__header {
                min-height: 70px;
                padding: 0;
                font-weight: 600;
                font-size: 1.5rem;
                color: var(--v-tertiary-base);


                @include updatedMedia(sm) {
                    font-size: 1.125rem;
                }

                &__icon i {
                    font-size: 1.8rem;
                    width: 15px;
                    vertical-align: middle;

                    @include updatedMedia(sm) {
                        font-size: 1.125rem;
                    }
                }
            }
        }
    }

    .m-accordion-risk-assessment__sub-accordion,
    .m-card-effectiveness-accordion-question {
        .v-expansion-panel__header {
            cursor: default;
            padding-right: .5rem;

            &:hover {
                background: var(--v-secondary-darken1)
            }
        }
    }
</style>
